export default {
  title: 'Adicionar cartão de crédito',
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    success: 'Cartão adicionado com sucesso',
  },
};
